export async function refreshAppNow() {
  try {
    if ('serviceWorker' in navigator) {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg) await reg.update();

      if (reg?.waiting) {
        reg.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!reloaded) {
          reloaded = true;
          window.location.reload();
        }
      });

      setTimeout(() => { if (!reloaded) window.location.reload(); }, 1500);
      return;
    }
  } catch (err) {
    // Ignore SW errors (offline/no registration). We’ll hard-reload below.
  }
  // No SW support or an error happened — hard reload
  window.location.reload();
}
